import React, { useEffect, useMemo, useState } from "react";
import PbUmkuService from "../../../../services/pbumku/PbumkuService";
import { Offcanvas } from "react-bootstrap";
import { formatDateTimeLocalDate } from "../../../../utilities/Utils";
import StatusPrimer from "../../../../utilities/primer/StatusPrimer";

const OffCanvasLog = ({ showLog, handleCloseLog, dataPrimer }) => {
    let pbumkuService = useMemo(() => new PbUmkuService(), [])
    const [listStatus, setListStatus] = useState(null)

    useEffect(() => {
        // console.log(datappm)
        if (!dataPrimer) return
        const fetchAllData = async () => {
            try {
                const response = await pbumkuService.listUmkuStatus(dataPrimer.nomorAju)
                // console.log(response)
                setListStatus(response.data)
            } catch (error) {
                setListStatus(null)
            }
        }
        fetchAllData()
    }, [pbumkuService, dataPrimer])

    return (
        <>
            <Offcanvas
                show={showLog}
                onHide={handleCloseLog}
                placement='end'
            >
                <Offcanvas.Header closeButton>
                    <div className="d-flex align-items-center">
                        <h5>
                            Log Status Permohonan
                        </h5>
                    </div>
                </Offcanvas.Header>
                <Offcanvas.Body>
                    <div className="iq-timeline0 m-0 d-flex align-items-center justify-content-between position-relative">
                        <ul className="list-inline p-0 m-0 w-100">
                            {
                                listStatus && listStatus.map((sts, index) => {
                                    return (
                                        <li key={index}>
                                            <div className="timeline-dots timeline-dot1 border-danger text-primary"></div>
                                            <h6 className="float-left mb-1"><StatusPrimer kodeStatus={sts.kodeStatus} /></h6>
                                            <small>Waktu : {formatDateTimeLocalDate(sts.waktuStatus)}</small>
                                        </li>
                                    )
                                })
                            }
                        </ul>
                    </div>
                </Offcanvas.Body>
            </Offcanvas>
        </>
    )
}

export default OffCanvasLog